import {
  Box,
  BoxProps,
  Flex,
  IconButton,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
import Sidebar from "./Sidebar";
import { MainProvider, useMain } from "../../contexts/MainContext";
import { HamburgerIcon } from "@chakra-ui/icons";

const Authenticated = ({ children }: BoxProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const sidebarIsOpen = useBreakpointValue({
    base: isOpen,
    lg: false,
  });

  return (
    <Flex flexDirection="column" bg="#f8fdff" h="100%">
      <Box
        position="relative"
        bgColor="#fff"
        boxShadow="rgba(0, 0, 0, 0.08) 0px 2px 8px"
        zIndex={1}
        py={3}
        px={3}
        display={{ lg: "none" }}
      >
        <IconButton
          aria-label="Menu"
          icon={<HamburgerIcon boxSize="24px" />}
          variant="icon"
          onClick={onOpen}
        />
      </Box>

      <Flex flex={1} overflow="hidden">
        <Sidebar isOpen={sidebarIsOpen || false} onClose={onClose} />
        <Box flex={1} overflow="auto">
          <Box
            flex={1}
            maxW="none"
            pt="40px"
            pb="60px"
            overflowY="auto"
            px={{ md: "30px" }}
          >
            {children}
          </Box>
        </Box>
      </Flex>
    </Flex>
  );
};

const AuthenticatedMain = ({ children }: BoxProps) => {
  return (
    <MainProvider>
      <Authenticated>{children}</Authenticated>
    </MainProvider>
  );
};

export default AuthenticatedMain;
